import "./src/styles/app.scss"
import "./node_modules/@fontsource/lato/400.css"
import "./node_modules/@fontsource/lato/400-italic.css"
import "./node_modules/@fontsource/lato/700.css"
import "./node_modules/@fontsource/lato/700-italic.css"
import "./node_modules/@fontsource/playfair-display/700.css"
import "./node_modules/@fontsource/playfair-display/900.css"

import React from "react"
import Layout from "./src/components/layout";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};